var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { class: _vm.componentClass, style: _vm.componentStyle }, [
    _vm.isShowingSingleIconFeature
      ? _c("li", { class: _vm.featureClass }, [
          _c("span", [
            _c("i", { class: `fa-solid fa-xl fa-fw fa-${_vm.singleIconName}` }),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "margin-left-lg" }, [
            _vm._v(
              "All 9 styles of the “" + _vm._s(_vm.singleIconName) + "“ icon"
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: { icon: _vm.$v6.solid.faIcons, size: "xl", "fixed-width": "" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v(
            "All " +
              _vm._s(_vm.$counts.icons.all.formatted) +
              " icons in Font Awesome"
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faSwatchbook,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("Classic + Sharp styles of every icon"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faArrowDownToLine,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("Ability to download Pro icons"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faFileCertificate,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("A Perpetual license to Font Awesome Pro"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faSignalBars,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("More pageviews and custom icons"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faCloudArrowUp,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("Additional Pro plugins and services"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: { icon: _vm.$v6.solid.faBox, size: "xl", "fixed-width": "" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("Installation via Package Managers"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faToolbox,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("Services and tools to make easy work of using icons"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isShowingTokenFeature
      ? _c(
          "li",
          { class: _vm.featureClass },
          [
            _c("font-awesome-icon", {
              attrs: {
                icon: _vm.$v6.solid.faCoinFront,
                size: "xl",
                "fixed-width": "",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "margin-left-lg" }, [
              _vm._v("API and npm tokens to easily integrate Font Awesome"),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "li",
      { class: _vm.featureClass },
      [
        _c("font-awesome-icon", {
          attrs: {
            icon: _vm.$v6.solid.faParachuteBox,
            size: "xl",
            "fixed-width": "",
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "margin-left-lg" }, [
          _vm._v("Fresh icons, features, and software updates"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isShowingSupportFeature
      ? _c(
          "li",
          { class: _vm.featureClass },
          [
            _c("font-awesome-icon", {
              attrs: {
                icon: _vm.$v6.solid.faUserHeadset,
                size: "xl",
                "fixed-width": "",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "margin-left-lg" }, [
              _vm._v("Plus support from real humans"),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }